import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import games from '../games/manifest';
import { loadMaxPoints } from '../utils/useStreakPoints';
import { loadHistory, getAllStats } from '../utils/useGameHistory';
import './Progress.css';

export default function Progress() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const stats = getAllStats();
  const history = loadHistory();
  const maxPoints = loadMaxPoints();
  const accuracy = stats.played > 0 ? Math.round((stats.correct / stats.played) * 100) : 0;

  return (
    <div className="progress-page">
      <header className="progress-header">
        <button className="btn-back" onClick={() => navigate('/')}>
          &#8592; {t('progress.back')}
        </button>
        <h2>{t('progress.title')}</h2>
      </header>

      <div className="progress-content">

        <section className="progress-section">
          <h3>{t('progress.overview')}</h3>
          <div className="progress-overview">
            <div className="progress-stat">
              <span className="progress-stat-value">{stats.played}</span>
              <span className="progress-stat-label">{t('progress.totalRounds')}</span>
            </div>
            <div className="progress-stat">
              <span className="progress-stat-value">{stats.correct}</span>
              <span className="progress-stat-label">{t('progress.totalCorrect')}</span>
            </div>
            <div className="progress-stat">
              <span className="progress-stat-value">{stats.wrong}</span>
              <span className="progress-stat-label">{t('progress.totalWrong')}</span>
            </div>
            <div className="progress-stat">
              <span className="progress-stat-value">{accuracy}%</span>
              <span className="progress-stat-label">{t('progress.accuracy')}</span>
            </div>
          </div>
        </section>

        <section className="progress-section">
          <h3>{t('progress.perGame')}</h3>
          <div className="progress-games">
            {games.map((g) => {
              const Icon = g.icon;
              const h = history[g.id];
              const best = maxPoints[g.id];
              const gameAccuracy = h && h.played > 0 ? Math.round((h.correct / h.played) * 100) : null;

              return (
                <div key={g.id} className="progress-game-row" onClick={() => navigate(`/game/${g.id}`)}>
                  {Icon && <Icon className="progress-game-icon" />}
                  <div className="progress-game-info">
                    <span className="progress-game-title">{t(g.titleKey)}</span>
                    {h ? (
                      <span className="progress-game-stats">
                        {t('progress.played', { n: h.played })} &middot; {t('progress.correct', { n: h.correct })} &middot; {gameAccuracy}%
                        {best > 0 && <> &middot; {t('progress.bestPoints')}: {best}</>}
                      </span>
                    ) : (
                      <span className="progress-game-stats muted">{t('progress.notPlayed')}</span>
                    )}
                  </div>
                  {gameAccuracy !== null && (
                    <div className="progress-game-bar">
                      <div className="progress-game-fill" style={{ width: `${gameAccuracy}%` }} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
}
